import {SubscriptionSettingsFragment, WixPaymentApiPayV2SubscriptionFrequency} from '../../../../gql/graphql';
import {FreeTrialPeriodModel} from './FreeTrialPeriod.model';
import {SubscriptionFrequencyWithLiterals, SubscriptionSettings} from '@wix/auto_sdk_ecom_cart-v-2';

export class SubscriptionSettingsModel {
  public frequency: SubscriptionFrequency;
  public interval: number;
  public billingCycles: number;
  public startDate: string;
  public freeTrialPeriod: FreeTrialPeriodModel;
  public autoRenewal: boolean;

  constructor(params: SubscriptionSettingsModel) {
    this.frequency = params.frequency;
    this.interval = params.interval;
    this.billingCycles = params.billingCycles;
    this.startDate = params.startDate;
    this.freeTrialPeriod = params.freeTrialPeriod;
    this.autoRenewal = params.autoRenewal;
  }

  public static fromCheckoutV1(subscriptionSettings: SubscriptionSettingsFragment) {
    return new SubscriptionSettingsModel({
      frequency: toSubscriptionFrequencyV1(subscriptionSettings?.frequency),
      interval: subscriptionSettings?.interval ?? 0,
      billingCycles: subscriptionSettings?.billingCycles ?? 0,
      startDate: subscriptionSettings?.startDate ?? '',
      freeTrialPeriod: FreeTrialPeriodModel.fromCheckoutV1(subscriptionSettings?.freeTrialPeriod),
      autoRenewal: Boolean(subscriptionSettings?.autoRenewal),
    });
  }
  public static fromCartV2(subscriptionSettings: SubscriptionSettings) {
    return new SubscriptionSettingsModel({
      frequency: toSubscriptionFrequencyV2(subscriptionSettings?.frequency),
      interval: subscriptionSettings?.interval ?? 0,
      billingCycles: subscriptionSettings?.billingCycles ?? 0,
      startDate: subscriptionSettings?.startDate ? new Date(subscriptionSettings.startDate).getTime().toString() : '',
      freeTrialPeriod: FreeTrialPeriodModel.fromCartV2(subscriptionSettings?.freeTrialPeriod),
      autoRenewal: Boolean(subscriptionSettings?.autoRenewal),
    });
  }
}

export enum SubscriptionFrequency {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  UNDEFINED = 'UNDEFINED',
}

export const toSubscriptionFrequencyV1 = (frequency?: WixPaymentApiPayV2SubscriptionFrequency | null) => {
  switch (frequency) {
    case WixPaymentApiPayV2SubscriptionFrequency.DAY:
      return SubscriptionFrequency.DAY;
    case WixPaymentApiPayV2SubscriptionFrequency.WEEK:
      return SubscriptionFrequency.WEEK;
    case WixPaymentApiPayV2SubscriptionFrequency.MONTH:
      return SubscriptionFrequency.MONTH;
    case WixPaymentApiPayV2SubscriptionFrequency.YEAR:
      return SubscriptionFrequency.YEAR;
    /* istanbul ignore next */ default:
      return SubscriptionFrequency.UNDEFINED;
  }
};
export const toSubscriptionFrequencyV2 = (frequency?: SubscriptionFrequencyWithLiterals | null) => {
  switch (frequency) {
    case SubscriptionFrequency.DAY:
      return SubscriptionFrequency.DAY;
    case SubscriptionFrequency.WEEK:
      return SubscriptionFrequency.WEEK;
    case SubscriptionFrequency.MONTH:
      return SubscriptionFrequency.MONTH;
    case SubscriptionFrequency.YEAR:
      return SubscriptionFrequency.YEAR;
    /* istanbul ignore next */ default:
      return SubscriptionFrequency.UNDEFINED;
  }
};
